import React, { ReactElement, useEffect, useState } from "react";
import { useMapLayersContext } from "../provider/MapLayers";
import Tides from "./Tides";
import LayerFlood from "./LayerFlood";
import LayerWind from "./LayerWind";
import LayerAirPressure from "./LayerAirPressure";
import LayerTemperature from "./LayerTemperature";
import LayerRain from "./LayerRain";
import LayerRainProbability from "./LayerRainProbability";

const LayersWindow = () => {
  return (
    <>
      <div className="group">
        <span className="title">Weather</span>
        <div className="groupBody">
          <LayerWind name="Wind" />
          <LayerTemperature name="Temperature" />
          <LayerRain name="Accumulated Rain" />
          <LayerAirPressure name="Air pressure" />
             <Tides name="Tides" />
              <LayerRainProbability name="TP Rate" />
        </div>
      </div>
      {/* <div className="group">
        <span className="title">Rain</span>
        <div className="groupBody">
          <LayerRainProbability name="Rain Probability" />
        </div>
      </div> */}
      <div className="group">
        <span className="title">Flood</span>
        <div className="groupBody">
          <LayerFlood name="Flood" />
        </div>
      </div>
    </>
  );
};

export default LayersWindow;
